import { passportMeta, type PassportProfile } from '@/mocks/trace-passport';

interface PassportVerifyCardProps {
  profile: PassportProfile;
  onViewJourney: () => void;
}

export default function PassportVerifyCard({ profile, onViewJourney }: PassportVerifyCardProps) {
  return (
    <section className="px-4 pt-4">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-secondary-400 via-secondary-500 to-secondary-600 p-5 text-background-50">
        <div className="relative flex items-start gap-4">
          <span className="w-14 h-14 shrink-0 flex items-center justify-center rounded-2xl bg-background-50/20">
            <i className="ri-shield-check-line text-3xl"></i>
          </span>
          <div className="min-w-0 pt-0.5">
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background-50/20 text-[11px] font-medium whitespace-nowrap">
              <i className="ri-verified-badge-line"></i>
              {passportMeta.statusBadge}
            </span>
            <h1 className="mt-2.5 font-heading font-bold text-2xl leading-tight text-background-50 dark:text-background-50">
              {passportMeta.statusTitle}
            </h1>
            <p className="mt-1.5 text-sm text-background-50/85 leading-relaxed">
              {passportMeta.statusDesc}
            </p>
          </div>
        </div>

        <div className="mt-4 pt-3.5 border-t border-background-50/25 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-background-50/80">
          <span className="font-semibold text-background-50">{passportMeta.verifyPrefix}</span>
          <span>｜最近核验时间：{profile.verifyTime}</span>
        </div>

        <button
          type="button"
          onClick={onViewJourney}
          className="mt-3.5 w-full inline-flex items-center justify-center gap-1.5 py-2.5 rounded-full bg-background-50 text-secondary-700 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors hover:bg-background-100"
        >
          <i className="ri-route-line"></i>
          {passportMeta.journeyCta}
        </button>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2 text-xs text-foreground-500">
        <i className="ri-qr-scan-2-line text-secondary-600"></i>
        <span className="font-mono">{profile.code}</span>
      </div>
      <div className="mt-1 flex flex-wrap items-center justify-center gap-x-2 text-xs text-foreground-600">
        <span>{profile.product}</span>
        <span className="text-foreground-300">·</span>
        <span>{profile.origin}</span>
      </div>
    </section>
  );
}